module.exports = __webpack_public_path__ + "img/catamnesis.356ae0cd.jpg";